
let placeholder = {
    /* placeholder */
    enterKeyword: '请输入关键词',
    enterUsername: '请输入用户名',
    enterPass: '请输入密码',
    enterNewPass: '请输入新密码',
    enterPassAgain: '请再次输入密码',
    enterEmail: '请输入邮箱',
    selectGroup: '请选择用户组',
    selectSuperior: '请输入上级',
    enterName: '请输入姓名',
    enterPhone: '请输入手机号码',
    enterUserGroupCnName: '请输入用户组中文名称',
    enterUserGroupEnName: '请输入用户组英文名称',
    enterUserGroupCnDesc: '请输入用户组中文描述',
    enterUserGroupEnDesc: '请输入用户组英文描述',
    changeGroup: '请选择分组',
    /* message 提示 */
    addSuccess: '添加成功',
    editSuccess: '修改成功',
    adduserSuccess: '添加用户成功',
    edituserSuccess: '修改用户信息成功',
    adduserGroupSuccess: '添加用户组成功',
    adduserGroupError: '添加用户组失败',
    editGroupAuthSuccess: '修改用户组权限成功',
    editGroupAuthError: '修改用户组权限失败',
    editGroupStatusSuccess: '修改用户组状态成功',
    addLowerUserSuccess: '添加下级用户成功',
    confirmEmail: '您已发送此邮件，是否再次发送',
    sendCancle: '已取消发送',
    sendEmailSuccess: '邮件发送成功',
    /* 表单错误提示 */
    usernameIllegality: '用户名不正确',
    passIllegality: '密码不正确',
    emailIllegality: '邮箱不正确',
    nameIllegality: '姓名不正确',
    iphoneIllegality: '手机号码不正确',
    passagainError: '两次密码不一致',
    /* 发布消息 */
    enterMsgTitle: '请输入标题',
    enterMsgContent: '请输入内容',
    enterLowerUser: '请输入下级用户',
    /* 出金申请 */
    enterCorrectMoney: '请填写正确的金额',
    lackBalance: '余额不足',
    enterCorrectComment: '请填写正确的备注信息',
    


}

export default placeholder;




































// WEBPACK FOOTER //
// ./src/i18n/chinese/placeholder.js